// pkceService.ts

function base64UrlEncode(arrayBuffer: ArrayBuffer): string {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCodePoint(bytes[i]);
  }
  return btoa(binary)
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replace(/=+$/, "");
}

export interface GeneratePkcePairResult {
  verifier: string;
  challenge: string;
}

export async function generatePkcePair(
  isLogin?: boolean,
): Promise<GeneratePkcePairResult> {
  if (!globalThis.crypto?.subtle) {
    throw new Error(
      "WebCrypto API is unavailable. This usually happens when using HTTP instead of HTTPS on an IP address.",
    );
  }

  // Generate 32 random bytes for the verifier
  const randomBytes = new Uint8Array(32);
  globalThis.crypto.getRandomValues(randomBytes);
  const verifier = base64UrlEncode(randomBytes.buffer);

  // Create SHA-256 hash of the verifier for the challenge
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const hashBuffer = await globalThis.crypto.subtle.digest("SHA-256", data);
  const challenge = base64UrlEncode(hashBuffer);

  // Store verifier for the callback phase
  if (isLogin === true) {
    storeVerifier(verifier);
  }

  return { verifier, challenge };
}

// ---------------- Verifier Storage ----------------
const VERIFIER_KEY = "pkce_verifier";

function storeVerifier(verifier: string): void {
  localStorage.setItem(VERIFIER_KEY, verifier);
}

export function getStoredVerifier(): string | null {
  return localStorage.getItem(VERIFIER_KEY);
}

export function clearVerifier(): void {
  localStorage.removeItem(VERIFIER_KEY);
}

export const setCookie = (verifier: string) => {
  try {
    document.cookie = `codeVerifier=${verifier}; path=/; Secure; SameSite=None`;
  } catch (err) {
    console.log("Error in setCookie::", err);
  }
};

export const clearCookie = () => {
  document.cookie = `codeVerifier=; Max-Age=0; path=/; Secure; SameSite=None`;
};